export default __webpack_public_path__ + "static/media/Marjan Ahmed - Operations Associate.510fd8a2.jpg";